<template>
  <div class="withDraw">
      <el-steps :active="4" class="withDraw-stepBox">
        <el-step title="发起提现申请" icon="el-icon-admin-jinqian" :description="time.date1"></el-step>
        <el-step title="待审核" icon="el-icon-admin-daishenhe-copy" :description="time.date2"></el-step>
        <el-step title="商家携带发票对账" icon="el-icon-admin-fapiao" :description="time.date3"></el-step>
        <el-step title="待收款" icon="el-icon-admin-xianjinliuliangbiao" :description="time.date4"></el-step>
      </el-steps>
  
      <el-form ref="crashForm"  label-width="80px" class="crashForm">
        <el-form-item label="提现金额:" class="table-item-margin">
            <span>{{stepInfo.amount | fixed}} 元</span>
        </el-form-item>
        <el-form-item label="实际到账金额:" class="table-item-margin">
            <span>{{stepInfo.successCashAmount | fixed}} 元(扣除手续费)</span>
        </el-form-item>
        <el-form-item label="提现描述:" class="table-item-margin">
            <span>{{stepInfo.cashSubject}}</span>
        </el-form-item>
        <el-form-item label="审核结果:" class="table-item-margin">
            <span>{{stepInfo.platfSubject}}</span>
        </el-form-item>
      </el-form>
      <el-row class="message">*预计提现处理时间为7天，请及时关注处理进度</el-row>
    </div>
</template>
<script>
import logo from "../assets/images/step.png";
import suc from "../assets/images/arrowSuc.png";
import fail from "../assets/images/arrowFail.png";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      time: {
        date1: "",
        date2: "",
        date3: "",
        date4: ""
      },
      step: {
        date1: "发起提现申请",
        date2: "待审核",
        date3: "商家携带发票对账",
        date4: "待收款"
      },
      imgUrl: logo,
    };
  },
  computed: {
    stepInfo() {
      return this.$store.state.assetStatus;
    }
  },
  created() {
    this.getStepInfo();
  },
  methods: {
    ...mapActions(["getStepInfo"])
  }
};
</script>
<style lang="scss" scoped>
@import "../style/_withdraw";
.withDraw {
  background-color: #fff;
  margin: 0 16px;
}
.message {
  text-align: center;
  font-size: 12px;
  color: #6b6b6b;
  padding: 10px 0;
}
</style>




// WEBPACK FOOTER //
// src/components/Withdraw5.vue